import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InvoiceDetails<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: string;
  /** Alias: sumPurchasePrice */
  sumPurchasePrice?: number;
  /** Alias: dbPercent */
  dbPercent?: number;
  /** Alias: netValueMainCurrency */
  netValueMainCurrency?: number;
  /** Alias: grossValueMainCurrency */
  grossValueMainCurrency?: number;

  __typename?: string;
}

const fields: FieldDefinitions<InvoiceDetails> = {
  id: {
    alias: 'code',
  },
  sumPurchasePrice: {
    alias: 'sumPurchasePrice',
  },
  dbPercent: {
    alias: 'dbPercent',
  },
  netValueMainCurrency: {
    alias: 'netValueMainCurrency',
  },
  grossValueMainCurrency: {
    alias: 'grossValueMainCurrency',
  },
  __typename: {
    alias: '__typename',
  },
};

export const invoiceDetailsEntityDefinition: EntitiyDefinition<InvoiceDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InvoiceDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
